module.exports = __webpack_public_path__ + "img/img-funcionalidades-medida.644c6d5a.png";